/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_FoundInputs */

const en_not_found = /** @type {(inputs: Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not Found`)
};

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const es_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const fr_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const de_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const ja_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const zh_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const ar_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const id_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const it_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const ru_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const pt_not_found = en_not_found;

/** @type {(inputs: Not_FoundInputs) => LocalizedString} */
const ko_not_found = en_not_found;

/**
* | output |
* | --- |
* | "Not Found" |
*
* @param {Not_FoundInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const not_found = /** @type {((inputs?: Not_FoundInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_FoundInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_not_found(inputs)
	if (locale === "es") return es_not_found(inputs)
	if (locale === "fr") return fr_not_found(inputs)
	if (locale === "de") return de_not_found(inputs)
	if (locale === "ja") return ja_not_found(inputs)
	if (locale === "zh") return zh_not_found(inputs)
	if (locale === "ar") return ar_not_found(inputs)
	if (locale === "id") return id_not_found(inputs)
	if (locale === "it") return it_not_found(inputs)
	if (locale === "ru") return ru_not_found(inputs)
	if (locale === "pt") return pt_not_found(inputs)
	return ko_not_found(inputs)
});